import React from "react";
import {Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery, useTheme} from "@mui/material";
import {GRADE_COLOR_MAPPING} from "../../utils/constants";

const ratingLevels = [
    {
        color: GRADE_COLOR_MAPPING['A'],
        label: "EXCEPTIONAL",
        description: "World-class performance, exceeding global benchmarks"
    },
    {
        color: GRADE_COLOR_MAPPING['B'],
        label: "EFFECTIVE",
        description: "Consistently meets most targets with minor gaps"
    },
    {
        color: GRADE_COLOR_MAPPING['C'],
        label: "MODERATE",
        description: "Shows progress but requires further improvements"
    },
    {
        color: GRADE_COLOR_MAPPING['D'],
        label: "EMERGING",
        description: "Significant gaps exist, requiring urgent action"
    },
    {color: GRADE_COLOR_MAPPING['NA'], label: "DATA UNAVAILABLE", description: "Insufficient data for assessment"}
];

const CountryRanking = ({data}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    // Chunk array function
    const sortedData = [...data].sort((a, b) => a.name.localeCompare(b.name));

    const chunkArray = (arr, numChunks) => {
        const result = [];
        const chunkSize = Math.ceil(arr.length / numChunks);
        for (let i = 0; i < numChunks; i++) {
            result.push(arr.slice(i * chunkSize, (i + 1) * chunkSize));
        }
        return result;
    };

    const chunkedData = chunkArray(sortedData, 4);

    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: 'center',
            pb: {xs:0, sm:10},
            gap: 5,
            paddingX: {xs:'20px',md:1,lg:4}
        }}>

            <Typography variant="h3" className="title" sx={{
                color: '#003C69',
                fontSize: {xs: '23px', sm: '45px'},
                width: {xs: '100%', lg: '70%'},
                fontWeight: 'bold',
                textAlign:'center',
                mx:'auto',
            }}>
                CHECK YOUR NATION’S CPC INDEX LEVEL
            </Typography>
            {/* Left Section */}
            <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', mx:{xs:undefined, md:'10px', lg:undefined}, flex: {md:'0 0 40%', lg:"0 0 30%"}}}>
                {/* Rating Levels */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-around",
                        flexDirection: { xs: "column", sm: "row", lg: "row" },
                        p: 2,
                        width: { xs: "95%", sm:'95%', lg: "75%" },
                        marginTop: "0px",
                        marginLeft: { xs: "-15px", sm:'0px', lg: "-30px" },
                    }}
                >
                    {ratingLevels.map((item, index) => (
                        <Box
                            key={index}
                            sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                px: 2,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 32,
                                    height: 32,
                                    backgroundColor: item.color,
                                    borderRadius: "50%",
                                    mb: 2,
                                }}
                            />
                            <Typography
                                sx={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    color: "#003c69",
                                }}
                            >
                                {item.label}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: "18px",
                                    textAlign: "center",
                                    color: "#5f6162",
                                }}
                            >
                                {item.description}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>

            {/* Right Section with horizontal scrolling */}
            <Box
                sx={{
                    overflowX: {xs:"auto",sm:'none'},
                    paddingRight: "10px",
                    mt:'20px',
                    mx:{xs:2, md:5, lg:8},
                '&::-webkit-scrollbar': {
                    width: '9px',
                    height:'9px',
                },
                '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#888',
                        borderRadius: '10px',
                },
                '&::-webkit-scrollbar-track': {
                        background: 'transparent',
                    },
                }}
            >
                <Box sx={{ display: "flex", gap: 2 }}>
                {chunkedData.map((group, columnIndex) => (
                        <TableContainer key={columnIndex} sx={{ flex: 1, overflowX:{xs:'visible', lg:'unset'} }}>
                            <Table sx={{borderCollapse: "collapse"}}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{
                                            color: '#027db6ff',
                                            fontSize: "18px",
                                            fontWeight: "bold",
                                            py: 0.7
                                        }}>Country</TableCell>
                                    <TableCell align="right"
                                               sx={{color: '#027db6ff', textAlign:'right', fontSize: "18px", fontWeight: "bold", py: 0.7}}>Level</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {group.map((country, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "8.4px 16px !important",
                                                border: "0 none",
                                                py: 0.7
                                            }}>
                                                <img
                                                    loading="lazy"
                                                    style={{width: "32px", height: "20px", marginRight: "8px"}}
                                                    src={require(`../../assets/flags-w80/${country.flag.toLowerCase()}.png`)}
                                                    alt={country.flag}
                                                />
                                                <Typography sx={{fontSize: "16px"}}>{country.name}</Typography>
                                            </TableCell>
                                            <TableCell align="right" sx={{
                                                width: "50px",
                                                padding: "8.4px 16px !important",
                                                border: "0 none",
                                                py: 0.7
                                            }}>
                                                <Box sx={{
                                                    width: 21,
                                                    height: 21,
                                                    backgroundColor: GRADE_COLOR_MAPPING[country.level] || "#CCCCCC",
                                                    borderRadius: "50%",
                                                    marginLeft: "auto",
                                                }}/>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ))}
                </Box>
            </Box>
        </Box>
    );
};

export default CountryRanking;
